<style>
  .userLogin{
    height:100%;
    width:auto;
    float:right;

  }
  .loginBtn{
    height:35px;
    border:1px solid #fff;
    border-radius:8px;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:35px;
    color:#fff;
    padding:0 10px;
    top:13px;
    float:right;
    position: relative;
    cursor: pointer;
    margin-left:30px;
  }
  .logout{
    font-size:15px;
    border:none
  }
  @media screen and (max-width:500px ) {
  	userLogin {
  		 float:right;
  	}
  	.userLogin .loginBtn {
  		height: 25px;
  		border-radius:8px;
  		font-size: 13px;
  		line-height:25px;
  		padding:0 5px;
  		top:7px;
  		margin-left:0;
  	}
  	.displayNone {
  		display: none;
  	}
  }
</style>

<template>
	<div class='userLogin'>
    <!-- <div class='loginBtn'  v-if='!isLogin' @click='gotoLogin'>注册/登录</div> -->
    <div class='loginBtn displayNone logout' v-if='isLogin' @click='logout'>退出登录</div>
    <!-- <div class='loginBtn' v-if='isLogin' @click='gotoPersen'>我的商城</div> -->
    <div class='loginBtn' @click='gotoPersen'>我的商城</div>
  </div>
</template>

<script>
  import autoLogin from '../util/autoLogin.js'
	export default {
		components:{

		},
		props:[],
		data() {
			return {
        isLogin:false
			}
		},
		computed: {

		},

		mounted() {
				let that = this
        if(localStorage.getItem('data')){
            this.isLogin=true
        }
		},
		methods: {
      gotoPersen(){
        // 现在只进入展厅，不用判断设备是否移动端，因为只有一个页面
        if (!localStorage.getItem('data')) {
          this.gotoLogin();
          return;
        }
        const userInfo = JSON.parse(localStorage.getItem('data'));
        window.location.href = `https://s.eggi.cn/exhibition/index.html?fid=${userInfo.id}&${autoLogin.makeEnP(userInfo.phone)}`
        // const sUserAgent = navigator.userAgent.toLowerCase();
        // const isMobile = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent);
        // // if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {

        // // }
        // if(localStorage.getItem('data')){
        //   let enP=autoLogin.makeEnP(JSON.parse(localStorage.getItem("data")).phone)
        //   if (isMobile) {
        //      //跳转手机端端页面
        //     window.location.href = "http://www.guigui.com.cn/mobile/?" + enP;
        //     return;
        //   }
        //   window.location.href='https://mall.eggi.cn?'+ enP
        // }else{
        //   if (isMobile) {
        //      //跳转手机端端页面
        //     window.location.href = "http://www.guigui.com.cn/mobile/";
        //     return;
        //   }
        //   window.location.href='mall.eggi.cn'
        // }
      },
      logout(){
        localStorage.removeItem('data')
        this.isLogin=false
        window.location.search = ''
        this.$message("退出登录成功")
        this.$emit("logout")
      },
      logon(){
        this.isLogin=true
      },
      gotoLogin(){
        // //待修改
        // this.$message({
        //   showClose: true,
        //   message: "暂时不支持业主注册",
        //   type: 'error'
        // })
        let pageTo=encodeURIComponent(location.href)
//      location.href='https://eggrj.com/login.html?other=true&pageTo='+pageTo
				location.href="./login.html?pageTo="+pageTo
      }
		}
	}
</script>
